/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_View_Numbers_TitleInputs */

const en_platform_view_numbers_title = /** @type {(inputs: Platform_View_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbers without Excel`)
};

const pl_platform_view_numbers_title = /** @type {(inputs: Platform_View_Numbers_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liczby bez Excela`)
};

/**
* | output |
* | --- |
* | "Numbers without Excel" |
*
* @param {Platform_View_Numbers_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_numbers_title = /** @type {((inputs?: Platform_View_Numbers_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Numbers_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_numbers_title(inputs)
	return en_platform_view_numbers_title(inputs)
});